import axios from "./axios";

export default {
    getCurrentlyInClinicByPatient(data) {
        const options = {
            method: 'POST',
            url: `patientlist2/getCurrentlyInClinicByPatient`,
            headers: { 'content-type': 'application/json' },
            data: data
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },
    registerPatient(data) {
        const options = {
            method: 'POST',
            url: 'patientlist2/registerPatient',
            headers: { 'content-type': 'application/json' },
            data: data
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                  resolve(response.data);
                })
                .catch(error => {
                  reject(error.message);
                })
        })
    },
    getDayPatients(data) {
        const options = {
            method: 'POST',
            url: 'patientlist2/getDayPatients',
            headers: { 'content-type': 'application/json' },
            data: data
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                  resolve(response.data);
                })
                .catch(error => {
                  reject(error.message);
                })
        })
    },
    updateStatusClinic(data) {
        const options = {
            method: 'POST',
            url: 'patientlist2/updateStatusClinic',
            headers: { 'content-type': 'application/json' },
            data: data
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                  resolve(response.data);
                })
                .catch(error => {
                  reject(error.message);
                })
        })
    }
    
}